/* dashboard/media_playback.js — event sound playback.
 *
 * Extracted from static/js/live.js on 2026-05-31 (Phase L4b of the
 * live.js refactor). Methods rely on `this` being bound to the dashboard
 * controller, so live.js delegates with .call(this, ...). Sound state lives
 * on the controller (this._audioCtx, this.soundOn, this._suppressSound).
 *
 * The in-card event animations, custom clip uploads and default media were
 * retired 2026-10-11 (Phase 5 settings review): they could only show on a
 * slate of four games or fewer, in Cards view, on a desktop.
 *
 * Public API (all called with controller as `this`):
 *   eventAllowsMedia(ev)            → bool (gates the event sound)
 *   getAudioCtx()                   → AudioContext | undefined
 *   playSoundForEvent(eventKey)   - 'nhl_goal_horn' sounds the goal horn, anything else the tick
 *
 * Depends on global playEventSound (static/sounds.js).
 */

window.LSMediaPlayback = {

  // Return true if this event should produce sound/media output.
  // Rule: if the event maps to a DB rule, gate on `event_type` — only
  // `achievement` and `big_play` celebrate. Mirrors the Settings → Media
  // event-library filter so what the user sees configurable is exactly
  // what plays. `allow_media` is no longer consulted (deprecated 2026-05-20).
  // Legacy fallback: events without a rule_id (NHL, soccer, EL sound_key
  // path) or sports without DB rules loaded still allow by default.
  eventAllowsMedia(ev) {
    // The CURRENT FORMAT's money event always celebrates. On a single-stat RBI/K
    // slate, RBI/K is the marquee moment — but it's routine (event_type null) on
    // Classic, so we celebrate it per-format here rather than globally big_play
    // (which would spam a Classic slate). Money event = format trait vidi_event.
    const fv = this.formatVariant || this._formatVariant || '';
    if (fv && window.LSFormat && ev.rule_id) {
      const money = window.LSFormat.traitsOf(fv).vidi_event || '';
      if (money && ev.rule_id === money) return true;
    }
    // Server scorer events carry event_type directly — prefer it, no rule lookup
    // needed. Fall back to the sport-level rules map otherwise (legacy paths).
    if (ev.event_type !== undefined && ev.event_type !== null) {
      return ev.event_type === 'achievement' || ev.event_type === 'big_play';
    }
    if (!ev.rule_id) return true;
    const sport = (this.selectedSlate?.sport_id || '').toLowerCase();
    const rules = this._vidiRulesBySport?.[sport];
    if (!rules || !rules.length) return true;
    const rule = rules.find(r => r.rule_id === ev.rule_id);
    if (!rule) return true;
    return rule.event_type === 'achievement' || rule.event_type === 'big_play';
  },

  getAudioCtx() {
    if (!this._audioCtx) {
      try { this._audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch(_) {}
    }
    if (this._audioCtx && this._audioCtx.state === 'suspended') {
      this._audioCtx.resume().catch(() => {});
    }
    return this._audioCtx;
  },

  playSoundForEvent(eventKey) {
    if (!this.soundOn || this._suppressSound) return;
    const ctx = this._getAudioCtx();
    if (!ctx) return;
    if (eventKey === 'nhl_goal_horn' && typeof playHockeyGoal === 'function') return playHockeyGoal(ctx);
    playEventSound(ctx);
  },

};
